import { ComboboxItem, Flex, Stack, Text } from '@mantine/core';
import {
  Dropzone,
  IMAGE_MIME_TYPE,
  MIME_TYPES,
  MS_WORD_MIME_TYPE,
  PDF_MIME_TYPE,
} from '@mantine/dropzone';
import { notifications } from '@mantine/notifications';
import React from 'react';
import classes from './DropZone.module.css';

type Props = {
  documentType: ComboboxItem;
  onFilesSelected: (files: File[]) => void;
};

export function DropZone({ onFilesSelected }: Props) {
  const handleFilesSelected = (files: File[]) => {
    onFilesSelected(files);
  };

  return (
    <Dropzone
      onDrop={handleFilesSelected}
      onReject={fileRejections => {
        fileRejections.forEach(fileRejection => {
          notifications.show({
            title: `Failed to upload ${fileRejection.file.name}`,
            message: fileRejection.errors.map(e => e.message).join('\n'),
            color: 'red',
          });
        });
      }}
      maxSize={2147483648} // 2GB
      style={{
        border: '1px dashed #b4bbc7',
        borderRadius: '16px',
        padding: '32px',
      }}
      maxFiles={5}
      accept={[
        ...PDF_MIME_TYPE,
        ...IMAGE_MIME_TYPE,
        ...MS_WORD_MIME_TYPE,
        MIME_TYPES.doc,
        MIME_TYPES.docx,
        'text/markdown',
        'text/plain',
        'audio/wav',
        'audio/mpeg',
        'audio/mp3',
        'audio/mp4',
        'video/mp4',
        'audio/x-wav',
        'audio/flac',
        'audio/ogg',
        'audio/x-flac',
      ]}
    >
      <Stack justify={'center'} align={'center'}>
        <Flex>
          <Text size="lg" className={classes.uploadLabel}>
            Upload
          </Text>
          <Text size="lg" fw={600}>
            &nbsp;your clients data or just drop a file here (DOCX, PDF, XLSX, XLS, MP3, MP4, WAV)
          </Text>
        </Flex>
      </Stack>
    </Dropzone>
  );
}
